import { FC } from 'react'

import {
  Card,
  CardContent,
  Chip,
  Cluster,
  Icon,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  Typography,
} from '@forto-dev/phoenix-ui-core'

import { BookingDTO } from '@/clients/booking'
import { useBookingHistoryQuery } from '@/features/bookings/api/booking'
import { useLocalisation } from '@/utils/localisation'

import {
  getBookingStateComment,
  mapBookingStateToChipVariant,
  mapBookingStateToTranslation,
} from '../utils/bookingStates'

type BookingStateChipProps = {
  state: BookingDTO['state'] | 'shipmentCreated'
  comment?: string
}
export const BookingStateChip: FC<BookingStateChipProps> = ({ state, comment }) => {
  const { translate } = useLocalisation()
  return (
    <Chip variant={mapBookingStateToChipVariant(state)}>
      <Cluster gap={4} y="center">
        {mapBookingStateToTranslation(state, translate)}
        {comment ? <Icon name="InfoCircle" size="sm" /> : null}
      </Cluster>
    </Chip>
  )
}

type BookingStateWidgetProps = {
  booking: BookingDTO
}

export const BookingStateWidget: FC<BookingStateWidgetProps> = ({ booking }) => {
  const { translate, translateDate } = useLocalisation()
  const { data: bookingHistoryData } = useBookingHistoryQuery(booking.id)
  const comment = getBookingStateComment({
    historyItems: bookingHistoryData?.items,
    state: booking.state,
    translateDate,
    translate,
  })

  const renderChip = () => {
    return <BookingStateChip state={booking.state} comment={comment} />
  }

  return (
    <Card>
      <CardContent>
        <Cluster gap={4} y="center">
          <Typography color="muted">{translate('booking.overview.status')}: </Typography>
          {comment ? (
            <Tooltip>
              <TooltipTrigger>
                <div>{renderChip()}</div>
              </TooltipTrigger>
              <TooltipContent>{comment}</TooltipContent>
            </Tooltip>
          ) : (
            renderChip()
          )}
        </Cluster>
      </CardContent>
    </Card>
  )
}
